<template>
  <Transition
    :mode="mode"
    :appear="appear"
    @before-enter="onBeforeEnter"
    @before-leave="onBeforeLeave"
    @enter="onEnter"
    @leave="onLeave"
    @enter-cancelled="onEnterCancelled"
    @leave-cancelled="onLeaveCancelled"
  >
    <slot />
  </Transition>
</template>

<script setup lang="ts">
  import { GsapTransition, type TransitionEvent } from '../../composables/GsapTransition'

  const props = defineProps<{
    appear: boolean
    mode?: 'out-in' | 'in-out' | null
    enter?: TransitionEvent
    leave?: TransitionEvent
    beforeLeave?: TransitionEvent
    beforeEnter?: TransitionEvent
  }>()

  const {
    active,
    onBeforeEnter,
    onBeforeLeave,
    onEnter,
    onLeave,
    onEnterCancelled,
    onLeaveCancelled
  } = GsapTransition.use({
    enter: props.enter,
    leave: props.leave,
    beforeEnter: props.beforeEnter,
    beforeLeave: props.beforeLeave
  })

  defineExpose({
    transitioning: active
  })
</script>

<style scoped></style>
